import { render, staticRenderFns } from "./comp_ProductCardImage.vue?vue&type=template&id=48777426&scoped=true&"
import script from "./comp_ProductCardImage.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCardImage.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCardImage.vue?vue&type=style&index=0&id=48777426&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48777426",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VHover})
